// Hardcoded HD artist data using Unsplash curated portrait + artwork images
const ARTISTS_DATA = [
  {
    id: 1,
    name: "Elena Marchetti",
    art_category: "Painter",
    location: "Florence, Italy",
    followers: 42800,
    bio: "Elena's large-scale oil paintings blend Renaissance technique with contemporary emotion, exhibited across Europe and New York.",
    profile_image: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=1200&q=90",
      "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=1200&q=90",
      "https://images.unsplash.com/photo-1549887534-1541e9326642?w=1200&q=90",
      "https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?w=1200&q=90",
      "https://images.unsplash.com/photo-1562059390-a761a084768e?w=1200&q=90",
      "https://images.unsplash.com/photo-1561214115-f2f134cc4912?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=1920&q=90",
    work_type: "Full Time",
    isPremium: true,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 2,
    name: "Kai Tanaka",
    art_category: "Digital Artist",
    location: "Tokyo, Japan",
    followers: 87500,
    bio: "Kai blurs the line between digital and physical — his immersive 3D renders have appeared in international exhibitions and album covers.",
    profile_image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=90",
      "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1200&q=90",
      "https://images.unsplash.com/photo-1633412802994-5c058f151b66?w=1200&q=90",
      "https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?w=1200&q=90",
      "https://images.unsplash.com/photo-1620121692029-d088224ddc74?w=1200&q=90",
      "https://images.unsplash.com/photo-1617791160505-6f00504e3519?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1920&q=90",
    work_type: "Freelancer",
    isPremium: true,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 3,
    name: "Sofia Reyes",
    art_category: "Photographer",
    location: "Mexico City, Mexico",
    followers: 31200,
    bio: "Sofia's documentary photography captures the soul of Latin American cities — raw, honest, and deeply human.",
    profile_image: "https://images.unsplash.com/photo-1589156280159-27698a70f29e?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1501854140801-50d01698950b?w=1200&q=90",
      "https://images.unsplash.com/photo-1472214103451-9374bd1c798e?w=1200&q=90",
      "https://images.unsplash.com/photo-1518173946687-a4c8892bbd9f?w=1200&q=90",
      "https://images.unsplash.com/photo-1505765050516-f72dcac9c60e?w=1200&q=90",
      "https://images.unsplash.com/photo-1439853949212-36os7b4c6a2e?w=1200&q=90",
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1501854140801-50d01698950b?w=1920&q=90",
    work_type: "Part Time",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 4,
    name: "Marcus Webb",
    art_category: "Sculptor",
    location: "London, UK",
    followers: 19700,
    bio: "Marcus crafts monumental bronze and steel sculptures that explore memory and impermanence, installed in public spaces worldwide.",
    profile_image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1561214115-f2f134cc4912?w=1200&q=90",
      "https://images.unsplash.com/photo-1544967082-d9d25d867d66?w=1200&q=90",
      "https://images.unsplash.com/photo-1553356084-58ef4a67b2a7?w=1200&q=90",
      "https://images.unsplash.com/photo-1574180566232-aaad1b5b8450?w=1200&q=90",
      "https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=1200&q=90",
      "https://images.unsplash.com/photo-1599847651338-07ca6e669f34?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1561214115-f2f134cc4912?w=1920&q=90",
    work_type: "Freelancer",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 5,
    name: "Amara Diallo",
    art_category: "Illustrator",
    location: "Dakar, Senegal",
    followers: 55300,
    bio: "Amara's vivid editorial illustrations have graced The New Yorker, TIME, and dozens of book covers across four continents.",
    profile_image: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?w=1200&q=90",
      "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=1200&q=90",
      "https://images.unsplash.com/photo-1545987796-200677ee1011?w=1200&q=90",
      "https://images.unsplash.com/photo-1597423498219-04418210827d?w=1200&q=90",
      "https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=1200&q=90",
      "https://images.unsplash.com/photo-1615184697985-c9bde1b07da7?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?w=1920&q=90",
    work_type: "Full Time",
    isPremium: true,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 6,
    name: "Luca Romano",
    art_category: "Photographer",
    location: "Milan, Italy",
    followers: 38900,
    bio: "Fashion and architecture photographer whose minimalist compositions have defined campaigns for Armani, Prada and Vogue Italia.",
    profile_image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1200&q=90",
      "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=1200&q=90",
      "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=1200&q=90",
      "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=1200&q=90",
      "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=1200&q=90",
      "https://images.unsplash.com/photo-1581044777550-4cfa60707c03?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1920&q=90",
    work_type: "Part Time",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 7,
    name: "Yuki Nakamura",
    art_category: "Digital Artist",
    location: "Osaka, Japan",
    followers: 72100,
    bio: "Yuki creates ethereal digital landscapes inspired by Japanese folklore, blending traditional aesthetics with futuristic environments.",
    profile_image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1534796636912-3b95b3ab5986?w=1200&q=90",
      "https://images.unsplash.com/photo-1485470733090-0aae1788d5af?w=1200&q=90",
      "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?w=1200&q=90",
      "https://images.unsplash.com/photo-1550684848-86a5d8727436?w=1200&q=90",
      "https://images.unsplash.com/photo-1547891654-e66ed7ebb968?w=1200&q=90",
      "https://images.unsplash.com/photo-1614850523296-d8c1af93d400?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1534796636912-3b95b3ab5986?w=1920&q=90",
    work_type: "Freelancer",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 8,
    name: "Nadia Okonkwo",
    art_category: "Painter",
    location: "Lagos, Nigeria",
    followers: 27600,
    bio: "Nadia's vibrant acrylic paintings celebrate African femininity and cultural identity, acquired by collectors in London and New York.",
    profile_image: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=1200&q=90",
      "https://images.unsplash.com/photo-1578301978018-3005759f48f7?w=1200&q=90",
      "https://images.unsplash.com/photo-1582561424760-0321d75e81fa?w=1200&q=90",
      "https://images.unsplash.com/photo-1605721911519-3dfeb3be25e7?w=1200&q=90",
      "https://images.unsplash.com/photo-1561214078-f3247d9ed6de?w=1200&q=90",
      "https://images.unsplash.com/photo-1616400619175-5beda3a17896?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=1920&q=90",
    work_type: "Part Time",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 9,
    name: "Henrik Larsen",
    art_category: "Sculptor",
    location: "Copenhagen, Denmark",
    followers: 14200,
    bio: "Henrik works in ceramic and glass, creating delicate forms that explore the fragility of nature and human connection.",
    profile_image: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1526285759904-71d1170ed2ac?w=1200&q=90",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=90",
      "https://images.unsplash.com/photo-1604928141064-207cea6f571f?w=1200&q=90",
      "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1200&q=90",
      "https://images.unsplash.com/photo-1548625149-720754874900?w=1200&q=90",
      "https://images.unsplash.com/photo-1551913902-c92207136625?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1526285759904-71d1170ed2ac?w=1920&q=90",
    work_type: "Freelancer",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 10,
    name: "Priya Sharma",
    art_category: "Illustrator",
    location: "Mumbai, India",
    followers: 61400,
    bio: "Priya's intricate pen-and-ink illustrations draw from Indian mythology and textile traditions, bridging heritage and modern design.",
    profile_image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1607604276583-eef5d076aa5f?w=1200&q=90",
      "https://images.unsplash.com/photo-1579541591970-dc37f4a9f042?w=1200&q=90",
      "https://images.unsplash.com/photo-1612528443702-f6741f70a049?w=1200&q=90",
      "https://images.unsplash.com/photo-1561409037-c7be81613c1f?w=1200&q=90",
      "https://images.unsplash.com/photo-1574158622682-e40e69881006?w=1200&q=90",
      "https://images.unsplash.com/photo-1549490349-8643362247b5?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1607604276583-eef5d076aa5f?w=1920&q=90",
    work_type: "Full Time",
    isPremium: true,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 11,
    name: "Owen Fitzgerald",
    art_category: "Photographer",
    location: "Dublin, Ireland",
    followers: 23800,
    bio: "Owen's long-exposure seascape and landscape photography captures the wild, unpredictable beauty of the Irish Atlantic coast.",
    profile_image: "https://images.unsplash.com/photo-1463453091185-61582044d556?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1505118380757-91f5f5632de0?w=1200&q=90",
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&q=90",
      "https://images.unsplash.com/photo-1511884642898-4c92249e20b6?w=1200&q=90",
      "https://images.unsplash.com/photo-1518173946687-a4c8892bbd9f?w=1200&q=90",
      "https://images.unsplash.com/photo-1501854140801-50d01698950b?w=1200&q=90",
      "https://images.unsplash.com/photo-1472214103451-9374bd1c798e?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1505118380757-91f5f5632de0?w=1920&q=90",
    work_type: "Part Time",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 12,
    name: "Zara Al-Hassan",
    art_category: "Digital Artist",
    location: "Dubai, UAE",
    followers: 49200,
    bio: "Zara's hyperrealistic digital portraits explore identity and belonging across cultures, shown at Art Dubai and Design Week.",
    profile_image: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?w=1200&q=90",
      "https://images.unsplash.com/photo-1620121692029-d088224ddc74?w=1200&q=90",
      "https://images.unsplash.com/photo-1617791160505-6f00504e3519?w=1200&q=90",
      "https://images.unsplash.com/photo-1633412802994-5c058f151b66?w=1200&q=90",
      "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1200&q=90",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?w=1920&q=90",
    work_type: "Freelancer",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 13,
    name: "Felix Braun",
    art_category: "Painter",
    location: "Berlin, Germany",
    followers: 33700,
    bio: "Felix's large abstract canvases, created with industrial pigments and palette knives, are held in private collections across Europe.",
    profile_image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1549887534-1541e9326642?w=1200&q=90",
      "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=1200&q=90",
      "https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?w=1200&q=90",
      "https://images.unsplash.com/photo-1562059390-a761a084768e?w=1200&q=90",
      "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=1200&q=90",
      "https://images.unsplash.com/photo-1605721911519-3dfeb3be25e7?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1549887534-1541e9326642?w=1920&q=90",
    work_type: "Full Time",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 14,
    name: "Isabelle Fontaine",
    art_category: "Illustrator",
    location: "Paris, France",
    followers: 44600,
    bio: "Isabelle's whimsical watercolor illustrations for children's books and editorial clients have won three international design awards.",
    profile_image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=1200&q=90",
      "https://images.unsplash.com/photo-1615184697985-c9bde1b07da7?w=1200&q=90",
      "https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?w=1200&q=90",
      "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=1200&q=90",
      "https://images.unsplash.com/photo-1597423498219-04418210827d?w=1200&q=90",
      "https://images.unsplash.com/photo-1545987796-200677ee1011?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=1920&q=90",
    work_type: "Part Time",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 15,
    name: "Tariq Hassan",
    art_category: "Photographer",
    location: "Cairo, Egypt",
    followers: 18900,
    bio: "Tariq's street photography distills the chaos and beauty of Cairo into intimate, cinematic frames.",
    profile_image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1539651044686-bc1e792c11c0?w=1200&q=90",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=90",
      "https://images.unsplash.com/photo-1534796636912-3b95b3ab5986?w=1200&q=90",
      "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?w=1200&q=90",
      "https://images.unsplash.com/photo-1550684848-86a5d8727436?w=1200&q=90",
      "https://images.unsplash.com/photo-1485470733090-0aae1788d5af?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1539651044686-bc1e792c11c0?w=1920&q=90",
    work_type: "Freelancer",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 16,
    name: "Maya Chen",
    art_category: "Digital Artist",
    location: "San Francisco, USA",
    followers: 93200,
    bio: "Maya's surreal 3D environments bridge science fiction and spirituality, with clients including Apple, Netflix and Nike.",
    profile_image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1617791160536-598cf32026fb?w=1200&q=90",
      "https://images.unsplash.com/photo-1633412802994-5c058f151b66?w=1200&q=90",
      "https://images.unsplash.com/photo-1620121692029-d088224ddc74?w=1200&q=90",
      "https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?w=1200&q=90",
      "https://images.unsplash.com/photo-1617791160505-6f00504e3519?w=1200&q=90",
      "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1617791160536-598cf32026fb?w=1920&q=90",
    work_type: "Full Time",
    isPremium: true,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 17,
    name: "Dmitri Volkov",
    art_category: "Sculptor",
    location: "Moscow, Russia",
    followers: 12300,
    bio: "Dmitri's monumental steel and concrete sculptures occupy public squares in Moscow, Prague and Berlin.",
    profile_image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=1200&q=90",
      "https://images.unsplash.com/photo-1553356084-58ef4a67b2a7?w=1200&q=90",
      "https://images.unsplash.com/photo-1574180566232-aaad1b5b8450?w=1200&q=90",
      "https://images.unsplash.com/photo-1599847651338-07ca6e669f34?w=1200&q=90",
      "https://images.unsplash.com/photo-1544967082-d9d25d867d66?w=1200&q=90",
      "https://images.unsplash.com/photo-1526285759904-71d1170ed2ac?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=1920&q=90",
    work_type: "Freelancer",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 18,
    name: "Cleo Martin",
    art_category: "Painter",
    location: "New Orleans, USA",
    followers: 29400,
    bio: "Cleo's expressionist oil paintings channel the jazz and blues of New Orleans — raw energy on canvas.",
    profile_image: "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1605721911519-3dfeb3be25e7?w=1200&q=90",
      "https://images.unsplash.com/photo-1616400619175-5beda3a17896?w=1200&q=90",
      "https://images.unsplash.com/photo-1561214078-f3247d9ed6de?w=1200&q=90",
      "https://images.unsplash.com/photo-1582561424760-0321d75e81fa?w=1200&q=90",
      "https://images.unsplash.com/photo-1578301978018-3005759f48f7?w=1200&q=90",
      "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1605721911519-3dfeb3be25e7?w=1920&q=90",
    work_type: "Part Time",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 19,
    name: "Raj Patel",
    art_category: "Illustrator",
    location: "Bangalore, India",
    followers: 37800,
    bio: "Raj creates bold geometric editorial illustrations for tech companies and magazines, with a distinctive Bauhaus-meets-India aesthetic.",
    profile_image: "https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1549490349-8643362247b5?w=1200&q=90",
      "https://images.unsplash.com/photo-1574158622682-e40e69881006?w=1200&q=90",
      "https://images.unsplash.com/photo-1561409037-c7be81613c1f?w=1200&q=90",
      "https://images.unsplash.com/photo-1612528443702-f6741f70a049?w=1200&q=90",
      "https://images.unsplash.com/photo-1579541591970-dc37f4a9f042?w=1200&q=90",
      "https://images.unsplash.com/photo-1607604276583-eef5d076aa5f?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1549490349-8643362247b5?w=1920&q=90",
    work_type: "Full Time",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
  {
    id: 20,
    name: "Luna Park",
    art_category: "Digital Artist",
    location: "Seoul, South Korea",
    followers: 81700,
    bio: "Luna's K-pop–influenced digital fashion illustrations have been featured in Vogue Korea and collaborated with major global brands.",
    profile_image: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=800&q=90",
    portfolio: [
      "https://images.unsplash.com/photo-1547891654-e66ed7ebb968?w=1200&q=90",
      "https://images.unsplash.com/photo-1550684848-86a5d8727436?w=1200&q=90",
      "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?w=1200&q=90",
      "https://images.unsplash.com/photo-1485470733090-0aae1788d5af?w=1200&q=90",
      "https://images.unsplash.com/photo-1534796636912-3b95b3ab5986?w=1200&q=90",
      "https://images.unsplash.com/photo-1614850523296-d8c1af93d400?w=1200&q=90",
    ],
    banner: "https://images.unsplash.com/photo-1547891654-e66ed7ebb968?w=1920&q=90",
    work_type: "Freelancer",
    isPremium: false,
    social_links: { instagram: "https://instagram.com", twitter: "https://twitter.com", website: "https://example.com" },
  },
];

export async function fetchArtists() {
  // Simulate a small async delay for skeleton UX
  await new Promise((r) => setTimeout(r, 600));
  return ARTISTS_DATA;
}